export default {
    legalEntities: [],
    numberOfNewPayments: 0
};
